









































import Vue from 'vue';
import RightSlidePopup from '@/components/popups/RightSlidePopup.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import { ICampaignGroup } from '@/types/campaign/groups';
import FieldRadioList from '@/components/form/FieldRadioList.vue';
import Button from '@/components/form/Button.vue';

export default Vue.extend({
  name: 'SelectGroupPopup',
  components: { RightSlidePopup, Preloader, FieldRadioList, Button },

  computed: {
    getGroups() {
      return this.$store.getters['campaignGroups/getGroups'];
    },
    groups(): Array<ICampaignGroup> {
      return (
        this.getGroups.map((group) => ({
          label: group.name,
          value: group.id,
        })) || []
      );
    },
  },

  methods: {
    async open() {
      this.loadGroups();
      return (this.$refs.popup as any).open();
    },
    close() {
      this.clearErrors();
    },
    change(id) {
      this.clearErrors();
      this.group = this.getGroups.find(group => group.id == id) || null;
    },
    confirm() {
      if (!this.group) {
        this.addError();
        return;
      }
      this.$emit('change', this.group);

      (this.$refs.popup as any).confirm();
    },
    async loadGroups() {
      if (this.groups.length) return;

      this.loadData = true;
      await this.$store.dispatch('campaignGroups/loadGroups', {
        searchData: {},
        columns: ['id', 'name'],
      });
      this.loadData = false;
    },
    addError() {
      this.errors.push(`${this.$t('notifications.selectGroup')}`);
    },
    clearErrors() {
      this.errors = [];
    },
  },

  data() {
    return {
      loadData: false,
      group: null,
      errors: [] as Array<string>,
    };
  },
});
